module.exports = __webpack_public_path__ + "img/3.07ae8a16.png";